// extracted by mini-css-extract-plugin
export default {"body":"layout_body__RiuTu","page":"layout_page__1cJSX"};